export interface IVideo {
  id: string;
  generateIframe(): void;
  load(): void;
}

/**
 * Video utilities
 * @class
 */
 export class Video implements IVideo {
  #element: HTMLElement;
  id: string;

  /**
   * @constructor
   * @param {HTMLElement} element The video element
   */
  constructor(element: HTMLElement) {
    this.#element = element;
    this.id = this.#element.dataset.videoId!;
  }

  load() {
    this.#element.innerHTML = this.generateIframe();
    this.#element.classList.add('e-video--loaded');
  }

  generateIframe() {
    return '';
  }
}